import invariant from 'invariant';
import DOMPurify from 'isomorphic-dompurify';
import querystring from 'query-string';
import authenticatedRequest from '../authenticatedRequest';
import labelRequest from '../labelRequest';

export default function getSearchResultsByTerm(params) {
    const { baseUrl, brandId, clientId, clientSecret, country, options, term, uberToken } = params;

    invariant(baseUrl, 'baseUrl is a required param of getSearchResultsByTerm()');
    invariant(brandId, 'brandId is a required param of getSearchResultsByTerm()');
    invariant(country, 'country is a required param of getSearchResultsByTerm()');
    invariant(term, 'term is a required param of getSearchResultsByTerm()');

    const localisedBrand = `${brandId}_${country.toLowerCase()}`;
    const decodedTerm = decodeURIComponent(term);
    const sanitizedTerm = DOMPurify.sanitize(decodedTerm, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] });
    const encodedSanitizedTerm = encodeURIComponent(sanitizedTerm);

    const queries = options ? `?${querystring.stringify(options)}` : '';
    const concatUrl = `${baseUrl}search/resources/store/${localisedBrand}/productview/bySearchTerm/${encodedSanitizedTerm}${queries}`;
    return labelRequest(authenticatedRequest(new Request(concatUrl), uberToken, clientId, clientSecret), 'getSearchResultsByTerm');
}
